export function formatValue(value: number | string, axes = false) {
  if (typeof value === "string") {
    return value;
  }

  const isNegative = value < 0;
  const absoluteValue = Math.abs(value);

  if (axes && absoluteValue >= 1000000) {
    const millions = (absoluteValue / 1000000).toFixed(absoluteValue < 100000000 ? 2 : 0);
    return isNegative ? `-${millions} M` : `${millions} M`;
  }

  let formattedValue;

  if (absoluteValue >= 100) {
    formattedValue = absoluteValue.toLocaleString('en-US', { maximumFractionDigits: 0 });
  } else {
    formattedValue = absoluteValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  return isNegative ? `-${formattedValue}` : formattedValue;
}


